import React from 'react';
import { AppBar, Toolbar, Box, Button } from '@mui/material';
import Logo from './Logo';
import { useNavigate } from 'react-router-dom';

const NavigationBar = ({ user, subscriptionStatus, onGetStarted, onPricing, onAbout, onContact, onLogout, onLogin, onLogoClick }) => {
  const navigate = useNavigate();
  return (
    <AppBar position="fixed" sx={{ 
      background: 'rgba(255, 255, 255, 0.1)', 
      backdropFilter: 'blur(10px)',
      borderBottom: '1px solid rgba(255, 255, 255, 0.2)',
      boxShadow: 'none'
    }}>
      <Toolbar sx={{ justifyContent: 'space-between' }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Box 
            onClick={() => navigate('/')}
            sx={{ 
              cursor: 'pointer',
              '&:hover': {
                opacity: 0.8
              }
            }}
          >
            <Logo />
          </Box>
        </Box>
        
        <Box sx={{ display: { xs: 'none', md: 'flex' }, gap: 4, alignItems: 'center' }}>
          {/*
          <Button 
            sx={{ color: '#fff', textTransform: 'none', fontSize: '1rem' }}
            onClick={() => {
              if (user) {
                if (subscriptionStatus && !subscriptionStatus.is_subscribed) {
                  onPricing();
                } else if (subscriptionStatus && subscriptionStatus.is_subscribed) {
                  navigate('/dashboard');
                }
              } else {
                onGetStarted();
              }
            }}
          >
            Dashboard
          </Button>
          <Button sx={{ color: '#fff', textTransform: 'none', fontSize: '1rem' }} onClick={onPricing}>Pricing</Button>
          */}
          <Button sx={{ color: '#fff', textTransform: 'none', fontSize: '1rem' }} onClick={() => navigate('/solution')}>Our Solution</Button>
          <Button sx={{ color: '#fff', textTransform: 'none', fontSize: '1rem' }} onClick={onAbout}>About</Button>
          <Button sx={{ color: '#fff', textTransform: 'none', fontSize: '1rem' }} onClick={onContact}>Contact</Button>
          <Button sx={{ color: '#fff', textTransform: 'none', fontSize: '1rem' }} onClick={() => navigate('/demo')}>Demo</Button>
        </Box>
        
        <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
          {user ? (
            <>
              <Button 
                variant="outlined" 
                sx={{ 
                  color: '#fff', 
                  borderColor: 'rgba(255, 255, 255, 0.3)',
                  textTransform: 'none',
                  '&:hover': {
                    borderColor: '#fff',
                    background: 'rgba(255, 255, 255, 0.1)'
                  }
                }}
              >
                {user.email}
              </Button>
              <Button 
                onClick={onLogout}
                sx={{
                  background: 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)',
                  color: '#fff',
                  textTransform: 'none',
                  '&:hover': {
                    background: 'linear-gradient(45deg, #FE6B8B 40%, #FF8E53 100%)',
                  }
                }}
              >
                Logout
              </Button>
            </>
          ) : (
            <>
              <Button 
                variant="outlined" 
                onClick={onLogin}
                sx={{ 
                  color: '#fff', 
                  borderColor: 'rgba(255, 255, 255, 0.3)',
                  textTransform: 'none',
                  '&:hover': {
                    borderColor: '#fff',
                    background: 'rgba(255, 255, 255, 0.1)'
                  }
                }}
              >
                Log in
              </Button>
              <Button 
                onClick={onGetStarted}
                sx={{
                  background: 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)',
                  color: '#fff',
                  textTransform: 'none',
                  '&:hover': {
                    background: 'linear-gradient(45deg, #FE6B8B 40%, #FF8E53 100%)',
                  }
                }}
              >
                Get Started
              </Button>
            </>
          )}
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default NavigationBar; 